// extracted by mini-css-extract-plugin
export default {"option":"option-c46d3049"};